/* jshint esversion: 6 */
/* jshint ignore:start */

import React, { useCallback, useContext, useEffect, useState } from 'react';
import ArrowUp from "../Icon/arrow-up.svg";
import { MyContext } from '../Context/MyProvider';
import axios from 'axios';
import Payment from '../PaymentMethod/Payment';
import { useTranslation } from 'react-i18next';
import { showTost } from '../showTost';
import Credit from "../images/icons/history-addion.png";
import Debit from "../images/icons/history-subs.png";
import LodingLottie from '../Lodinglottie';
const Wallet = () => {

    const { t } = useTranslation();

    const { basUrl, payClose, setPayClose, toggleButton, setToggleButton, setPageName, amount, setAmount, currency } = useContext(MyContext);

    const [coin, setCoin] = useState();
    const [purchase, setPurchase] = useState([]);
    const [loading, setLoading] = useState(true);

    const CoinHandler = useCallback(() => {
        const localData = localStorage.getItem("Register_User");

        if (localData) {
            const userData = JSON.parse(localData);
            axios
                .post(`${basUrl}wallet_report`, { uid: userData.id })
                .then((res) => {
                    if (res.data.Result === "true") {
                        setCoin(res.data.wallet);
                        setPurchase(res.data.Walletitem);
                        setLoading(false);
                    }
                })
                .catch((error) => {
                    console.error("Error fetching wallet data: ", error);
                    setLoading(false);
                });
        }
    }, [basUrl]);

    const SectionCloseHandler = useCallback(() => {
        setToggleButton(false);
        setPayClose("");
        localStorage.removeItem("PaymentDone");
        localStorage.removeItem("Amount");
    }, [setPayClose, setToggleButton]);

    const verifyHostedWalletReturn = useCallback((params, gatewayName) => {
        const localData = localStorage.getItem("Register_User");
        const storageKey = `${gatewayName}PendingPayment`;
        const pendingData = localStorage.getItem(storageKey);

        if (!localData) {
            showTost({ title: "Login required to verify payment." });
            return;
        }

        let pending = {};
        if (pendingData) {
            try {
                pending = JSON.parse(pendingData);
            } catch (err) {
                pending = {};
            }
        }

        const orderId = params.get("order_id") || pending.order_id;
        const gatewayReference = gatewayName === "Stripe"
            ? params.get("stripe_session_id") || pending.gateway_order_id
            : gatewayName === "PayStack"
                ? params.get("reference") || params.get("trxref") || pending.gateway_order_id
                : gatewayName === "FlutterWave"
                    ? params.get("tx_ref") || pending.gateway_order_id
                    : gatewayName === "MercadoPago"
                        ? params.get("preference_id") || pending.gateway_order_id
                        : gatewayName === "Khalti"
                            ? params.get("pidx") || pending.pidx || pending.gateway_order_id
                        : gatewayName === "Instamojo"
                            ? params.get("payment_request_id") || params.get("payment_request") || pending.payment_request_id || pending.gateway_order_id
                        : params.get("order_id") || pending.gateway_order_id;
        const gatewayTransactionId = params.get("transaction_id");
        const mercadoPagoPaymentId = params.get("payment_id") || params.get("collection_id");
        const instamojoPaymentId = params.get("payment_id") || params.get("payment");
        const tapChargeId = params.get("tap_charge_id") || params.get("charge_id") || params.get("id") || pending.tap_charge_id;
        const paydunyaToken = params.get("token") || params.get("invoice_token") || pending.invoice_token;
        const molliePaymentId = params.get("id") || params.get("payment_id") || pending.mollie_payment_id;
        const bkashPaymentId = params.get("paymentID") || params.get("payment_id") || pending.bkash_payment_id;

        if (!orderId || !gatewayReference) {
            showTost({ title: `${gatewayName} order details missing. Please retry payment.` });
            return;
        }

        const userData = JSON.parse(localData);
        axios.post(`${basUrl}verify_payment`, {
            uid: userData.id,
            order_id: orderId,
            stripe_session_id: gatewayName === "Stripe" ? gatewayReference : undefined,
            paystack_reference: gatewayName === "PayStack" ? gatewayReference : undefined,
            reference: gatewayName === "PayStack" ? gatewayReference : undefined,
            flutterwave_transaction_id: gatewayName === "FlutterWave" ? gatewayTransactionId : undefined,
            transaction_id: gatewayName === "FlutterWave" ? gatewayTransactionId : undefined,
            tx_ref: gatewayName === "FlutterWave" ? gatewayReference : undefined,
            collection_id: gatewayName === "MercadoPago" ? mercadoPagoPaymentId : undefined,
            preference_id: gatewayName === "MercadoPago" ? gatewayReference : undefined,
            pidx: gatewayName === "Khalti" ? gatewayReference : undefined,
            payment_request_id: gatewayName === "Instamojo" ? gatewayReference : undefined,
            payment_id: gatewayName === "Instamojo" ? instamojoPaymentId : (gatewayName === "MercadoPago" ? mercadoPagoPaymentId : undefined),
            tap_charge_id: gatewayName === "Tap" ? tapChargeId || gatewayReference : undefined,
            charge_id: gatewayName === "Tap" ? tapChargeId || gatewayReference : undefined,
            paydunya_token: gatewayName === "PayDunya" ? paydunyaToken || gatewayReference : undefined,
            invoice_token: gatewayName === "PayDunya" ? paydunyaToken || gatewayReference : undefined,
            mollie_payment_id: gatewayName === "Mollie" ? molliePaymentId || gatewayReference : undefined,
            bkash_payment_id: gatewayName === "bKash" ? bkashPaymentId || gatewayReference : undefined,
            paymentID: gatewayName === "bKash" ? bkashPaymentId || gatewayReference : undefined,
            gateway_order_id: gatewayReference,
        })
            .then((res) => {
                if (res.data.Result === "true" && res.data.status === "granted") {
                    showTost({ title: "Payment verified successfully." });
                    localStorage.removeItem(storageKey);
                    SectionCloseHandler();
                    CoinHandler();
                    window.history.replaceState({}, document.title, window.location.pathname);
                } else {
                    showTost({ title: res.data.ResponseMsg || `${gatewayName} payment verification pending.` });
                }
            })
            .catch(() => {
                showTost({ title: `Unable to verify ${gatewayName} payment.` });
            });
    }, [basUrl, CoinHandler, SectionCloseHandler]);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const gateway = params.get("payment_gateway") || params.get("gateway");
        const paymentStatus = params.get("payment_status");

        if (gateway === "Stripe" && paymentStatus === "success") {
            verifyHostedWalletReturn(params, "Stripe");
        } else if (gateway === "PayStack" && paymentStatus === "success") {
            verifyHostedWalletReturn(params, "PayStack");
        } else if (gateway === "FlutterWave" && paymentStatus === "success") {
            verifyHostedWalletReturn(params, "FlutterWave");
        } else if (gateway === "Payfast" && paymentStatus === "success") {
            verifyHostedWalletReturn(params, "Payfast");
        } else if (gateway === "Midtrans" && paymentStatus === "success") {
            verifyHostedWalletReturn(params, "Midtrans");
        } else if ((gateway === "2checkout" || gateway === "2Checkout") && paymentStatus === "success") {
            verifyHostedWalletReturn(params, "2checkout");
        } else if (gateway === "MercadoPago" && paymentStatus === "success") {
            verifyHostedWalletReturn(params, "MercadoPago");
        } else if ((gateway === "Khalti" || gateway === "Khalti Payment") && paymentStatus === "success") {
            verifyHostedWalletReturn(params, "Khalti");
        } else if (gateway === "Cashfree" && paymentStatus === "success") {
            verifyHostedWalletReturn(params, "Cashfree");
        } else if (gateway === "SSLCommerz" && paymentStatus === "success") {
            verifyHostedWalletReturn(params, "SSLCommerz");
        } else if (gateway === "Instamojo" && paymentStatus === "success") {
            verifyHostedWalletReturn(params, "Instamojo");
        } else if (gateway === "Tap" && paymentStatus === "success") {
            verifyHostedWalletReturn(params, "Tap");
        } else if (gateway === "PerfectMoney" && paymentStatus === "success") {
            verifyHostedWalletReturn(params, "PerfectMoney");
        } else if (gateway === "PayDunya" && paymentStatus === "success") {
            verifyHostedWalletReturn(params, "PayDunya");
        } else if (gateway === "Mollie" && paymentStatus === "success") {
            verifyHostedWalletReturn(params, "Mollie");
        } else if (gateway === "bKash" && paymentStatus === "success") {
            verifyHostedWalletReturn(params, "bKash");
        } else if ((gateway === "Stripe" || gateway === "PayStack" || gateway === "FlutterWave" || gateway === "Payfast" || gateway === "Midtrans" || gateway === "2checkout" || gateway === "2Checkout" || gateway === "MercadoPago" || gateway === "Khalti" || gateway === "Khalti Payment" || gateway === "Cashfree" || gateway === "SSLCommerz" || gateway === "Instamojo" || gateway === "Tap" || gateway === "PerfectMoney" || gateway === "PayDunya" || gateway === "Mollie" || gateway === "bKash") && paymentStatus === "cancelled") {
            showTost({ title: "Payment cancelled." });
            window.history.replaceState({}, document.title, window.location.pathname);
        }

        const Done = localStorage.getItem("PaymentDone");
        if (Done === "PaymentDoneWallet") {
            setPayClose("PaymentDone");
            setAmount(localStorage.getItem("Amount"));
        }
        CoinHandler();
    }, [CoinHandler, setAmount, setPayClose, verifyHostedWalletReturn]);

    const handleWalletUpdate = useCallback(() => {
        const localData = localStorage.getItem("Register_User");
        if (localData) {
            const userData = JSON.parse(localData);
            axios.post(`${basUrl}wallet_up`, {
                uid: userData.id,
                wallet: amount,
            })
                .then((res) => {
                    SectionCloseHandler();
                    showTost({ title: res.data.ResponseMsg });
                    CoinHandler();
                })
                .catch((error) => {
                    showTost({ title: "Somthing Want Wrong!!" });
                });
        }
    }, [amount, basUrl, CoinHandler, SectionCloseHandler]);

    useEffect(() => {
        if (payClose) {

            if (payClose === "PaymentDone") {
                handleWalletUpdate();
            } else if (payClose === "PaymentVerified") {
                showTost({ title: "Payment verified successfully." });
                SectionCloseHandler();
                CoinHandler();
            } else {
                showTost({ title: "Payment Failed..!!" });
                SectionCloseHandler();
            }
        }
    }, [payClose, handleWalletUpdate, SectionCloseHandler, CoinHandler]);

    return (
        <div className='bg-[#e5e5e5] main-wrapper-history'>
            {/* <!-- Main Content Start --> */}
            <div className="content-body">
                <div className="container-fluid pt-5 pb-[20px] px-sm-4 px-3">
                    <div className="row">
                        <div className="col-xl-12 max-_430_:fixed max-_430_:rounded-[10px] max-_430_:bg-[#e5e5e5] top-[70px] left-0 right-0 z-[444] max-_430_:pt-[15px]">
                            <div className="card card-rounded mb-4">
                                <div className="card-body card-py-1 flex justify-between items-center">
                                    <div className="person-header">
                                        <div className="fw-medium fs-15">{t('Total Balance')}</div>
                                        <h2 className='m-0 text-[30px]'>{currency ? currency : "$"}{coin ? coin : "0"}</h2>
                                    </div>
                                    <button onClick={() => { setToggleButton(true); setPageName("Wallet") }} className="flex items-center gap-[10px] bg-[#980EFF] text-white rounded-full px-[8px] py-[5px]">
                                        <img src={ArrowUp} alt="" className='bg-white rounded-full p-[7px] w-[30px] h-[30px]' />
                                        <h6 className='mt-[8px]'>{t("Top-up")}</h6>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-12 z-[333] ">
                            <div className="card card-rounded-1 max-_430_:mt-[75px]">
                                {purchase.length > 0
                                    ? <div className="card-body">
                                        <h5>{t('Transaction')}</h5>
                                        <div className="mt-[20px]">
                                            {purchase?.map((item, index) => (
                                                <div
                                                    className="w-[100%] ps-[30px] mb-[20px] pe-[50px] max-_430_:ps-[10px] max-_430_:pe-[10px] py-[20px] justify-between border-[2px] flex items-center rounded-[25px]"
                                                    key={index}
                                                >
                                                    <div className="flex items-center gap-[30px] max-_430_:gap-[10px]">
                                                        <img src={item.status === "Credit" ? Credit : Debit} className={`w-[40px] h-[40px] rounded-full`} alt="Caredit Debit" />
                                                        <div>
                                                            <h6 className="m-0 text-[18px] max-_430_:text-[15px]">{item.message}</h6>
                                                            <h6 className="m-0 text-[14px] text-gray-500 tracking-[1px]">{item.status}</h6>
                                                        </div>
                                                    </div>
                                                    <h6 className={`${item.status === "Credit" ? "text-green-500" : "text-red-500"} m-0 text-[18px] max-_430_:text-[16px]`}>
                                                        {item.status === "Credit" ?
                                                            (`+${currency ? currency : "$"}${item.amt}`) :
                                                            (`-${currency ? currency : "$"}${item.amt}`)
                                                        }
                                                    </h6>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    : <div className="h-[400px] flex justify-center items-center">
                                        <h3>{t('No any Transaction...')}</h3>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- Main Content End --> */}

            {/* ======== Payment Method ============== */}
            {toggleButton &&
                <Payment />
            }

            {loading && (
                <div className="w-[100%] h-[100vh] ms-[8rem] max-_991_:ms-0 bg-white fixed flex items-center justify-center top-0 left-0 right-0 bottom-0 z-[555]">
                    <LodingLottie ClassCss={"w-[20%] max-_430_:w-[100%] max-_770_:w-[50%] max-_1030_:w-[40%] max-_1145_:w-[30%] max-_1200_:w-[30%] max-_1300_:w-[30%]"} />
                </div>
            )}

        </div>

    )
}

export default Wallet
/* jshint ignore:end */
